import { Routes } from '@angular/router';
import { ApiContactsService } from '../../contacts/contact-us.service';

/**
 * The three content pages: the estimator FAQ, the terms, and contact us.
 *
 * Mounted twice, and the two mounts differ in exactly one thing. On the
 * estimator host `v2.routes.ts` spreads them into the guarded v2 table, so
 * they inherit `data: { v2: true }` and `AuthGuard`. On the briefings host
 * `core.routes.ts` spreads them into the anonymous group instead, which
 * carries the same `v2: true` and no auth guard: static marketing and legal
 * text, and requiring an account to read the terms is not a boundary worth
 * keeping (design doc §4). The paths are the ones the rail already points at
 * — `v2-nav.ts` links "Estimator FAQ" to `/v2/faq` — so nothing about
 * navigation changes on either host.
 *
 * `loadComponent` rather than `component`: the terms page is a 55KB template
 * and the FAQ another 15KB, and neither belongs in the bundle somebody
 * downloads to price a trip.
 *
 * `ApiContactsService` is provided on its route rather than at the root
 * because it is declared `@Injectable()` with no `providedIn` — the old app
 * registers it on `ContactsModule`. Reused exactly as it is; the v2 page does
 * not fork it.
 */
export const v2ContentRoutes: Routes = [
  {
    path: 'faq',
    loadComponent: () => import('./v2-faq.component').then(m => m.V2FaqComponent),
    data: { pageName: 'EVO Apps | Estimator FAQ' },
  },
  {
    path: 'terms',
    loadComponent: () => import('./v2-terms.component').then(m => m.V2TermsComponent),
    data: { pageName: 'EVO Apps | Terms & Conditions' },
  },
  {
    path: 'contacts',
    loadComponent: () => import('./v2-contacts.component').then(m => m.V2ContactsComponent),
    providers: [ApiContactsService],
    data: { pageName: 'EVO Apps | Contact us' },
  },
];
